import SyncableModel from './SyncableModel';

export default class ShrimpPrice extends SyncableModel {
  static name = 'ShrimpPrice'

  _fillable = [
    "id",
    "species_id",
    "date",
    "size_20", "size_30", "size_40", "size_50", "size_60", "size_70",
    "size_80", "size_90", "size_100", "size_110", "size_120", "size_130",
    "size_140", "size_150", "size_160", "size_170", "size_180", "size_190", "size_200",
    "remark",
    "created_by", "updated_by",
    "created_at", "updated_at",
    "region_id",
    "contact",
    "country_id",
    "currency_id",
    "private"
  ]

  incrementing = false

  static syncOnly = true

  static hasSyncedAt = false

  _casts = {
    size_20: "float",
    size_30: "float",
    size_40: "float",
    size_50: "float",
    size_60: "float",
    size_70: "float",
    size_80: "float",
    size_90: "float",
    size_100: "float",
    size_110: "float",
    size_120: "float",
    size_130: "float",
    size_140: "float",
    size_150: "float",
    size_160: "float",
    size_170: "float",
    size_180: "float",
    size_190: "float",
    size_200: "float",
    private: "boolean"
  }

  static endpoint = '/shrimp_prices'

  static online = true
}
